// Hooks
import { useMenu } from '@/utils/hooks/menu/useMenu';

// Types
import type { MenuEntryWithSubEntriesType } from '@/lib/platform/menu/menu';

// Components
import Icon from '@/components/base/Icon';
import { MenuIcon } from '@/components/layouts/LayoutPlatform/components/Menu/components/MenuEntry';
import { SubEntries } from '@/components/layouts/LayoutPlatform/components/Menu/components/SubEntries';
import { SettingsLogout } from '@/components/layouts/LayoutPlatform/components/SettingsWrapper/SettingsLogout';
import { SettingsMenu } from '@/components/layouts/LayoutPlatform/components/SettingsWrapper/SettingsMenu';

type MenuMobileSubEntriesProps = {
    activeEntry: string;
    toggleSubEntries: () => void;
};

export function MenuMobileSubEntries({ activeEntry, toggleSubEntries }: MenuMobileSubEntriesProps) {
    const { mainMenu, bottomMenu } = useMenu();

    if (!activeEntry) {
        return null;
    }

    const menu = [...mainMenu, ...bottomMenu];
    const entry = menu.find((entry) => entry.id === activeEntry) as MenuEntryWithSubEntriesType;

    return (
        <div className="flex flex-1 flex-col">
            <button
                data-testid="button-back-sub-entry"
                className="flex items-center gap-2 focus:ring-0 focus:ring-offset-0"
                onClick={toggleSubEntries}>
                <Icon className="text-icoGray-400 dark:text-icoDarkMode-wolf" icon="chevron-left" />
                <MenuIcon icon={entry.icon} id={entry.id} isActive />
                <span className="text-sm text-icoBlue">{entry.name}</span>
            </button>
            {entry.id === 'settings' ? (
                <div className="flex flex-1 flex-col justify-between">
                    <SettingsMenu />
                    <SettingsLogout />
                </div>
            ) : (
                <SubEntries className="pt-8" subMenuItems={entry.subMenuItems} isMenuOpen />
            )}
        </div>
    );
}
